export class CalendarEventCategoryListDTO {

    id: string;

    name: string;

    description: string;

    backgroundColor: string;

    borderColor: string;

    textColor: string;

}
